import { useState } from "react"
import { M_Button, M_InputTextField, M_SimpleTable, M_CheckBox } from "../../../../M_Components";
import { useTranslation } from "react-i18next";

export const DropdownForm = ({ propertyChangeCallback, field, languages, canEdit }) => {

    const [t, i18n] = useTranslation();
    const [dropdownOptions, setDropdownOptions] = useState({
        pt: "",
        es: "",
        en: ""
    });

    const hasAtLeastOneOption = () => {
        var hasAtLeastOneOption = false;
        for (let language in dropdownOptions) {
            if (dropdownOptions.hasOwnProperty(language)) {
                if (dropdownOptions[language] !== '') {
                    hasAtLeastOneOption = true;
                }
            }
        }

        return hasAtLeastOneOption;
    }

    const rows = field.dropdownItems ?
        [
            ...field?.dropdownItems?.filter(i => !i.isDeleted && !i.IsDeleted).map((item, index) => {
                // Support both camelCase and PascalCase from backend
                const captions = item.captions || item.Captions || {};
                const dropdownItemId = item.dropdownItemId || item.DropdownItemId;

                return {
                    id: dropdownItemId ?? index,
                    ...captions,
                    default_command: <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            canEdit &&
                            <M_Button
                                tooltip={t("NgeDelete")}
                                icon={<i className='pi pi-trash'></i>}
                                onClick={() => handleDelete(index)}
                            />
                        }
                    </div>
                }
            })
        ]
        : [];

    const columns = [
        ...languages.map(l => ({
            id: l.LanguageId || l.languageId,
            field: l.LanguageCode || l.languageCode,
            header: t(l.LanguageCode || l.languageCode)
        })),
        {
            id: 0,
            field: "default_command",
            header: "",
            style: { width: '80px', textAlign: 'right' }
        }
    ];

    const handleDropdownChange = (language, value) => {
        setDropdownOptions({
            ...dropdownOptions,
            [language]: value
        })
    }

    const handleSaveOption = () => {

        if (dropdownOptions.en.length === 0){
            return;
        }

        const newItem = {
            captions: {
                ...dropdownOptions
            },
            isDeleted: false
        };
        const dropdownItems = field.dropdownItems ? [
            ...field.dropdownItems,
            newItem
        ] :
            [
                newItem
            ];
        propertyChangeCallback("dropdownItems", dropdownItems);
        setDropdownOptions({
            pt: "",
            en: "",
            es: ""
        })
    }

    const handleDelete = (index) => {
        const itemToDelete = field.dropdownItems[index];
        const itemId = itemToDelete.dropdownItemId || itemToDelete.DropdownItemId;

        if (!itemId) {
            const newArray = [...field.dropdownItems];
            newArray.splice(index, 1);
            propertyChangeCallback("dropdownItems", newArray);
        } else {
            propertyChangeCallback("dropdownItems", field.dropdownItems.map((f, i) => i === index ? {
                ...f,
                isDeleted: true,
                IsDeleted: true
            } : f));
        }
    }

    return (
        <>
         <div className="field-one-columns" style={{ marginTop: "10px" }}>
                <M_CheckBox
                    label={t("NgeAllowMultiple")}
                    checked={field.allowMultiple ?? false}
                    disabled={!canEdit}
                    onChange={(e) => propertyChangeCallback("allowMultiple", e.target.checked)}
                />
            </div>
            <div className="field-two-columns box" style={{ marginTop: "10px" }}>
                <div className="field-two-columns" style={{ display: "flex" }}>
                    <div className="text-medium" style={{ alignContent: "center" }}>
                        {t("NgeDropdownOptions")}
                    </div>

                   

                </div>
                <div className="field-two-columns" style={{ display: "flex", marginLeft: 'auto' }}>
                    {canEdit &&
                        languages.map((l, i) => {
                            const langCode = l.LanguageCode;
                            return (
                                <div key={langCode} className={i === languages.length - 1 ? "" : "with-margin"}>
                                    <M_InputTextField
                                        label={`${t(langCode)} ${langCode === 'en' ? `(${t("NgeRequired")})` : ''}`}
                                        value={dropdownOptions[langCode] ?? ""}
                                        onChange={(e) => handleDropdownChange(langCode, e.target.value)}
                                        disabled={!canEdit}
                                    />
                                </div>
                            )
                        })
                    }
                     {canEdit && 
                        <M_Button
                            tooltip={t("NgeAddOption")}
                            label={t("NgeAddOption")}
                            icon={<i className='pi pi-plus'></i>}
                            disabled={!hasAtLeastOneOption()}
                            onClick={handleSaveOption}
                        />}
                </div>
                <div className="field-two-columns">
                    {field.dropdownItems && field.dropdownItems.length > 0 ? (
                        <M_SimpleTable
                            rows={rows}
                            columns={columns}
                        />
                    ) : (
                        <div style={{ padding: '20px', textAlign: 'center', color: 'var(--color-grey)' }}>
                            {t("NgeNoOptionsYet") || "No options added yet"}
                        </div>
                    )}
                </div>
            </div>
           
        </>
    )
}
